import { TRADABLES_TYPE } from "@helpers/constants";
import { Index as OldIndex } from "@models/asset/index/index.model";
import { Tradable, TradableAdapter } from "../tradable";

export interface Index extends Tradable {
	indexOriginalFiatSymbol: string;
	indexProvider: string;
}

export class IndexAdapter extends TradableAdapter {
	public adapt(index: OldIndex): Index {
		const tradable = super.adapt(index);
		return {
			...tradable,
			indexOriginalFiatSymbol: index.getIndexOriginalFiatSymbol(),
			indexProvider: index.getIndexProviderName(),
			type: TRADABLES_TYPE.INDEX
		};
	}
}
